export default function MobileList({ children }) {
  return (
    <ul className="divide-y divide-primary/20 bg-mgs-bg">
      {children}
    </ul>
  );
}
